import $axios from '@/services/api-koperasi'
import { defineStore } from 'pinia'
import type { Invoice, InvoiceDetail, Saldo } from './type'

declare interface GetSaving {
  success: string
  data: string
}

export const useSavingStore = defineStore('saving', {
  state: () => ({
    saldo: {} as Saldo,
    invoice: [] as Invoice[],
    detail: {} as InvoiceDetail,
  }),
  actions: {
    getSaving() {
      return new Promise<GetSaving>((resolve, reject) => {
        $axios
          .get('/get-saldo')
          .then((res) => {
            this.saldo = res.data.data
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getInvoice() {
      return new Promise<GetSaving>((resolve, reject) => {
        $axios
          .get('/get-invoice')
          .then((res) => {
            this.invoice = res.data.data
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getInvoiceDetail(code: string) {
      return new Promise<GetSaving>((resolve, reject) => {
        $axios
          .get(`/get-invoice/${code}`)
          .then((res) => {
            this.detail = res.data.data
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
})
